module.exports = __webpack_public_path__ + "img/snow-leopard-icon.9d0e782a.png";